document.addEventListener("DOMContentLoaded", function () {
	var btn = document.querySelector(".slide-nav__btn button");
	var close = document.querySelector(".ebs-page-overview__top--nav__close");
	var pageNav = document.querySelector(".ebs-page-overview");

	function closePageNav() {
		if (pageNav.classList.contains("ebs-page-overview__active")) {
			pageNav.classList.remove("ebs-page-overview__active");
		} else {
			pageNav.classList.add("ebs-page-overview__active");
		}
	}

	btn.addEventListener("click", function () {
		closePageNav();
	});
	close.addEventListener("click", function () {
		closePageNav();
	});
});

jQuery(function ($) {
	$("#editieLink").on("click", function (e) {
		e.preventDefault();
		console.log("clicked");
		$(".ebs-page-overview__pages--covers").addClass(
			"ebs-page-overview__pages--covers__active"
		);
		$(this).addClass("top-nav-active");
		$.ajax({
			type: "POST",
			url: "/wp-admin/admin-ajax.php",
			dataType: "html",
			data: {
				action: "ebs_load_pages",
				posttype: $(this).data("type"),
			},
			beforeSend: function () {
				console.log("loading");
				$(".ebs-page-overview__pages--covers__wrap").addClass(
					"ebs-page-overview__pages--covers__wrap--loading"
				);
			},
			success: function (res) {
				$(".ebs-page-overview__pages--covers__wrap").html(res);
				$(".ebs-page-overview__pages--covers__wrap").removeClass(
					"ebs-page-overview__pages--covers__wrap--loading"
				);
				console.log("loadied");
			},
		});
	});
});

document.addEventListener("DOMContentLoaded", function () {
	var pageLink = document.getElementById("pagesLink");
	var editieLink = document.getElementById("editieLink");
	var editionView = document.querySelector(".ebs-page-overview__pages--covers");

	function activeToggler() {
		if (pageLink.classList.contains("top-nav-active")) {
			pageLink.classList.remove("top-nav-active");
			editieLink.classList.add("top-nav-active");
		} else {
			pageLink.classList.add("top-nav-active");
			editieLink.classList.remove("top-nav-active");
			editionView.classList.remove("ebs-page-overview__pages--covers__active");
		}
	}

	pageLink.addEventListener("click", function () {
		activeToggler();
	});

	editieLink.addEventListener("click", function () {
		activeToggler();
	});
});

/* -------------------------------------------------------------------------- */
/*                         Next / previous navigation                         */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
	var currentPage = document.querySelector(".slide-menu__item--active");
	var nextPage = currentPage.nextElementSibling;
	var prevPage = currentPage.previousElementSibling;

	var nextBtn = document.querySelector(".slide-page__wrap--next");
	var prevBtn = document.querySelector(".slide-page__wrap--prev");

	if (nextPage !== null) {
		nextBtn.href = nextPage.children[0].href;
		if (nextBtn.classList.contains("slide-page__wrap--disabled")) {
			nextBtn.classList.remove("slide-page__wrap--disabled");
		}
	} else if (nextPage === null) {
		nextBtn.classList.add("slide-page__wrap--disabled");
	}

	if (prevPage !== null) {
		prevBtn.href = prevPage.children[0].href;
		if (prevBtn.classList.contains("slide-page__wrap--disabled")) {
			prevBtn.classList.remove("slide-page__wrap--disabled");
		}
	} else if (prevPage === null) {
		prevBtn.classList.add("slide-page__wrap--disabled");
	}
	window.addEventListener('keydown', function (event) {
		switch (event.key) {
			case 'ArrowLeft':
				// Go to the previous page if it exists
				if (prevPage !== null) {
					window.location.href = prevPage.children[0].href;
				}
				break;
			case 'ArrowRight':
				// Go to the next page if it exists
				if (nextPage !== null) {
					window.location.href = nextPage.children[0].href;
				}
				break;
		}
	});
});

/* -------------------------------------------------------------------------- */
/*                                page counter                                */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
	var slideMenu = document.querySelector(".slide-menu");
	var slideMenuChildren = slideMenu.children;

	var current = document.getElementById("currentPage");

	for (var i = 0; i < slideMenuChildren.length; i++) {
		if (slideMenuChildren[i].classList.contains("slide-menu__item--active")) {
			console.log("Current page = " + i);
			current.innerText = i + 1;
			break;
		}
	}
});

/////
document.addEventListener("DOMContentLoaded", function () {
	if (document.documentElement.scrollHeight > window.innerHeight) {
		var scroller = document.createElement("div");
		scroller.id = "scroller";
		if (document.querySelector('.wp-site-blocks') && document.querySelector('.wp-block-post-content').children.length > 1) {
			var content = document.querySelector('.wp-site-blocks');
			content.style.position = "relative";
			content.appendChild(scroller);
			scroller.addEventListener("click", function () {
				const contentEl = document.querySelector('.wp-block-post-content');
				const secondElement = contentEl.children[1]; // get the second element
				if (secondElement) {
					secondElement.scrollIntoView({ behavior: 'smooth' });
				}
			});
		}
	}
});

/* -------------------------------------------------------------------------- */
/*                                  Scroller                                  */
/* -------------------------------------------------------------------------- */

var debounce = function debounce(fn) {
	var frame;

	return function () {
		for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
			params[_key] = arguments[_key];
		}

		if (frame) {
			cancelAnimationFrame(frame);
		}

		frame = requestAnimationFrame(function () {
			fn.apply(void 0, params);
		}

		);
	};
};

var storeScroll = function storeScroll() {
	document.documentElement.dataset.scroll = window.scrollY;
};

document.addEventListener('scroll', debounce(storeScroll), {
	passive: true
}

);
storeScroll();

/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
	if (document.querySelector('iframe')) {
		const parent = document.querySelector('iframe').parentElement;
		parent.classList.add('iframe-container');
		if(window.screen.width < 1024){
			
		}
	}
});